const filterType = document.querySelector('.js-news-filter-type');
const filterShowcase = document.querySelector('.js-news-showcases-only');

const NewsOverview = {
    init() {
        if (filterType && filterShowcase) {
            filterType.addEventListener('change', this.onChange);
            filterShowcase.addEventListener('change', this.onChange);
        }
    },
    onChange() {
        let url = `/news`;
        if (filterType.value !== 'update') {
            url += `?type=${filterType.value}`;

            if (filterShowcase.checked) {
                url += `&showcase=1`;
            }
        } else if (filterShowcase.checked) {
            url += `?showcase=1`;
        }

        window.location.replace(url);
    },
};

export default NewsOverview;
